module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Clock-e0523b82f1c32f85269534ec57ea79a2.svg";